"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROVIDER_DISPLAY = exports.PROVIDER = exports.INVOICE_STATUS_DISPLAY = exports.INVOICE_STATUS = exports.INVOICE_TYPE_DISPLAY = exports.INVOICE_TYPE = void 0;
var INVOICE_TYPE;
(function (INVOICE_TYPE) {
    INVOICE_TYPE["B2B"] = "B2B";
    // B2C = 'B2C',
    INVOICE_TYPE["B2C_DONATE"] = "B2C_DONATE";
    INVOICE_TYPE["B2C_PHONE_CARRIER"] = "B2C_PHONE_CARRIER";
    INVOICE_TYPE["B2C_NPC"] = "B2C_NPC";
    INVOICE_TYPE["B2C_PROVIDER"] = "B2C_PROVIDER";
})(INVOICE_TYPE = exports.INVOICE_TYPE || (exports.INVOICE_TYPE = {}));
exports.INVOICE_TYPE_DISPLAY = {
    B2B: '三聯式發票(開立統一編號)',
    // B2C = 'B2C', 紙本發票
    B2C_DONATE: '捐贈',
    B2C_PHONE_CARRIER: '手機載具',
    B2C_NPC: '自然人憑證條碼',
    B2C_PROVIDER: '電子發票載具',
};
var INVOICE_STATUS;
(function (INVOICE_STATUS) {
    INVOICE_STATUS["pending"] = "pending";
    INVOICE_STATUS["success"] = "success";
    INVOICE_STATUS["failure"] = "failure";
})(INVOICE_STATUS = exports.INVOICE_STATUS || (exports.INVOICE_STATUS = {}));
exports.INVOICE_STATUS_DISPLAY = {
    pending: '等候開立',
    success: '開立成功',
    failure: '開立失敗',
};
var PROVIDER;
(function (PROVIDER) {
    PROVIDER["ecpay"] = "ecpay";
})(PROVIDER = exports.PROVIDER || (exports.PROVIDER = {}));
exports.PROVIDER_DISPLAY = {
    ecpay: '綠界科技',
};
